import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M3.46 23.3383H23.54C25.5933 23.3383 26.8733 21.1116 25.8467 19.3383L15.8067 1.99162C14.78 0.218288 12.22 0.218288 11.1933 1.99162L1.15333 19.3383C0.126666 21.1116 1.40667 23.3383 3.46 23.3383ZM13.5 14.005C12.7667 14.005 12.1667 13.405 12.1667 12.6716V10.005C12.1667 9.27162 12.7667 8.67162 13.5 8.67162C14.2333 8.67162 14.8333 9.27162 14.8333 10.005V12.6716C14.8333 13.405 14.2333 14.005 13.5 14.005ZM12.1667 19.3383H14.8333V16.6716H12.1667V19.3383Z";

export default function Warning(props: IconProps) {
  return (
    <SVGIcon
      path={path}
      viewBox="0 0 27 24"
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    />
  );
}
